import React, { createContext, useState } from 'react';

const HighlightContext = createContext();

export const HighlightProvider = ({ children }) => {
  const [highlightedSection, setHighlightedSection] = useState(null);

  return (
    <HighlightContext.Provider value={{ highlightedSection, setHighlightedSection }}>
      {children}
    </HighlightContext.Provider>
  );
};

export default HighlightContext;